import React, { useCallback } from "react";

import { ICommentChild } from "../../../store/types";
import { Avatar } from "../..";

import "./Child.styles.scss";
import { FindTargetRefType } from "../Section/Section";
import { useCommentsUrlHooks, useFormatDateHook } from "hooks";

interface IChild {
  comment: ICommentChild;
  findTargetRef: FindTargetRefType;
}

export const Child: React.FC<IChild> = ({ comment, findTargetRef }) => {
  const { user, created_at, id } = comment;
  const { replyId } = useCommentsUrlHooks();

  const setTargetRef = useCallback(
    (ref: HTMLDivElement) => (replyId === id ? findTargetRef(ref) : null),
    [replyId, id]
  );

  const formatDate = useFormatDateHook();

  return (
    <div ref={setTargetRef} className="child opacity-appearance">
      <div className="child__content flex-col-fs-fs">
        <div className="flex-row-fs-fc">
          <Avatar size={30} className="child__avatar" src={user?.profile_photo_url} />
          <div className="flex-col-fs-fs">
            <span className="child__user-name">{`${user?.first_name} ${user?.last_name}`}</span>
            <span className="child__date">{formatDate({ date: created_at, format: "HH:mm, MMM DD, YYYY" })}</span>
          </div>
        </div>
        <div className="child__message-wrap">
          <span>{comment?.text}</span>
        </div>
      </div>
    </div>
  );
};
